import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import MeasurementTable from './MeasurementTable.json';
import StudyList from './StudyList.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import StudyBrowser from './StudyBrowser.json';
import SidePanel from './SidePanel.json';
import Modes from './Modes.json';
import PatientInfo from './PatientInfo.json';
import Notification from './Notification.json';
import ContextMenu from './ContextMenu.json';
import Dialog from './Dialog.json';
import Modals from './Modals.json';
import Local from './Local.json';
import ErrorBoundary from './ErrorBoundary.json';

export default {
  'zh': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Header,
    MeasurementTable,
    StudyList,
    UserPreferencesModal,
    ViewportDownloadForm,
    StudyBrowser,
    SidePanel,
    Modes,
    PatientInfo,
    Notification,
    ContextMenu,
    Dialog,
    Modals,
    Local,
    ErrorBoundary,
  },
};